<template>
    <b-modal
        ref="show-modal"
        :title="$t('segment.show_player_modal.title')"
        cancel-title="Close"
        ok-only
        size="lg"
    >
      <div class="row">
        <div class="col-12">
          <table class="table">
            <tr>
              <th>{{ $t('segment.show_player_modal.id') }}</th>
              <td>{{ data.playerId }}</td>
            </tr>
            <tr>
              <th>{{ $t('segment.show_player_modal.email') }}</th>
              <td>{{ data.playerEmail }}</td>
            </tr>
            <tr>
              <th>{{ $t('segment.show_player_modal.segment_id') }}</th>
              <td>{{ data.segmentId }}</td>
            </tr>
          </table>
        </div>
      </div>
    </b-modal>
</template>


<script>

//TODO: import / load / get locale the right way
let locale = locale ? locale : "en";

export default {
  data() {
    return {
      data: {
        id: null,
      }
    };
  },
  filters: {},
  mounted() {
    this.showModal();
  },
  methods: {
    setData(data) {
      this.data = data;
    },
    showModal(){
      this.$refs['show-modal'].show();
    }
  }
}
</script>
